import React, { useCallback } from "react";
import "./titleBar.scss";
import deckhouseUserImg from "../../assets/deckhouseUser.jpeg";
import { TUserContext } from "../../appContext";

export const TitleBar = ({userContext}: {userContext: TUserContext}) => {

    const onClickUser = useCallback(() => {
        if (!userContext.loggedIn) {
            userContext.setShowModal({prompt: "Hello and welcome."});
        }
    }, [userContext.loggedIn, userContext.setShowModal]);

    return <div className="title-bar-container">
        <div className="title-bar-left">
            <div className="title-bar">
                Hello, {userContext.loggedIn ? 
                        (userContext.user.firstName || userContext.user.username ) :
                        "Guest"}
            </div>
            <div className="subtitle-bar">
                What do you want to cook today?
            </div>
        </div>
        <div className="title-bar-right">
            <div onClick={onClickUser}>
                <img src={deckhouseUserImg} alt="deckhouse" />
            </div>
            {/* TODO @emikyu - Use user image if available else placeholder */}
        </div>
</div>;
}